const CARD_HEIGHT = 307;

export const getAnimateProps = (
  isExpanded,
  columnPosition,
  isTablet = false,
  isMobile = false,
  cardBaseWidth = 384,
  gridGap = 24
) => {
  const columnsCount = isTablet ? 2 : 3;
  const expandedWidth = cardBaseWidth * columnsCount + gridGap * (columnsCount - 1);

  if (!isExpanded) {
    return {
      width: cardBaseWidth,
      left: 0,
      right: 'auto',
      x: 0,
      height: isMobile ? 'auto' : CARD_HEIGHT,
    };
  }

  if (isMobile) {
    return {
      width: cardBaseWidth,
      left: 0,
      right: 'auto',
      x: 0,
      height: 'auto',
    };
  }

  if (columnPosition === 0) {
    return {
      width: expandedWidth,
      left: 0,
      right: 'auto',
      x: 0,
      height: CARD_HEIGHT,
    };
  }

  const lastColumn = columnsCount - 1;
  if (columnPosition === lastColumn) {
    return {
      width: expandedWidth,
      left: 'auto',
      right: 0,
      x: 0,
      height: CARD_HEIGHT,
    };
  }

  return {
    width: expandedWidth,
    left: 0,
    right: 'auto',
    x: -(cardBaseWidth + gridGap),
    height: CARD_HEIGHT,
  };
};
